const styles = {
  wrapper: {
    display: 'flex',
    marginBottom: '4px',
  },
  sent: {
    justifyContent: 'flex-end',
  },
  received: {
    justifyContent: 'flex-start',
  },
  bubble: {
    maxWidth: '75%',
    padding: '10px 14px',
    borderRadius: '18px',
    fontSize: '14px',
    lineHeight: 1.4,
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap',
  },
  sentBubble: {
    background: 'var(--accent)',
    color: '#fff',
    borderBottomRightRadius: '4px',
  },
  receivedBubble: {
    background: 'var(--bg-elevated)',
    color: 'var(--text-primary)',
    borderBottomLeftRadius: '4px',
  },
  time: {
    fontSize: '10px',
    color: 'var(--text-muted)',
    marginTop: '2px',
    padding: '0 4px',
  },
  readReceipt: {
    fontSize: '10px',
    color: 'var(--text-muted)',
    textAlign: 'right',
    padding: '0 4px',
  },
};

function formatTime(dateStr) {
  const date = new Date(dateStr);
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

export default function MessageBubble({ message, isSent, showTime }) {
  return (
    <div>
      <div style={{ ...styles.wrapper, ...(isSent ? styles.sent : styles.received) }}>
        <div
          style={{
            ...styles.bubble,
            ...(isSent ? styles.sentBubble : styles.receivedBubble),
          }}
        >
          {message.content}
        </div>
      </div>
      {showTime && (
        <div style={{ ...styles.time, textAlign: isSent ? 'right' : 'left' }}>
          {formatTime(message.created_at)}
          {isSent && (
            <span style={styles.readReceipt}>
              {message.read_at ? ' ✓✓' : ' ✓'}
            </span>
          )}
        </div>
      )}
    </div>
  );
}
